<template>
  <div>
    Job board Metrics
    <div class="card maadi-dark-card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <div class="d-flex align-items-center p-1">
              <div class="p-1">
                Date 1
              </div>
              <div class="p-1">
                <b-form-datepicker size="sm" v-model="filter.date_1_start"></b-form-datepicker>
              </div>
              <div class="">
                -
              </div>
              <div class="p-1">
                <b-form-datepicker size="sm" v-model="filter.date_2_end"></b-form-datepicker>
              </div>
            </div>
            <div class="d-flex align-items-center p-1">
              <div class="p-1">
                Date 2
              </div>
              <div class="p-1">
                <b-form-datepicker size="sm" v-model="filter.date_2_start"></b-form-datepicker>
              </div>
              <div class="">
                -
              </div>
              <div class="p-1">
                <b-form-datepicker size="sm" v-model="filter.date_2_end"></b-form-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data: function () {
    return {
      filter: {
        date_1_start: null,
        date_1_end: null,
        date_2_start: null,
        date_2_end: null
      }
    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/jobBoard/JobBoardMetrics.vue